export interface ApiConfig {
  baseURL: string;
  timeout: number;
}

export const DEFAULT_API_CONFIG: ApiConfig = {
  baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:5000',
  timeout: 30000,
};
